import { render, staticRenderFns } from "./DentalAndOrthodontic.vue?vue&type=template&id=54d64cae"
import script from "./DentalAndOrthodontic.vue?vue&type=script&lang=js"
export * from "./DentalAndOrthodontic.vue?vue&type=script&lang=js"
import style0 from "./DentalAndOrthodontic.vue?vue&type=style&index=0&id=54d64cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports